// extracted by mini-css-extract-plugin
export default {"cls1":"NlVEDYM99hoPFER8PMp1","cls2":"SBiIoeUiE4BWFheV4KNK NlVEDYM99hoPFER8PMp1"};